// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apps-checkboxes[data-v-30f414c2] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 6px 0;\n}\n.error[data-v-30f414c2] {\n  color: red;\n  font-size: 13px;\n  margin-top: -8px;\n  margin-bottom: 6px;\n}\n.created-key-box[data-v-30f414c2] {\n  margin-top: 16px;\n  padding: 12px;\n  background: #f5f8fa;\n  border: 1px solid #cbd6e2;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
